import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getVendorDetails } from '../../../store/actions/shared/Shared';
import Loader from 'react-loader-spinner';
import {
  getAllProducts,
  getSubCategory,
  getSubCategoryProducts
} from '../../../store/actions/user/User';
import store from '../../../store/reducers/rootReducer';

class Shop2 extends Component {
  componentWillMount() {
    var category = this.props.match.params.category;
    var uid = this.props.match.params.uid;
    var subCategory = this.props.match.params.subCategory;
    this.props.getVendorDetails(uid);
    if (subCategory === 'all') {
      this.props.getAllProducts(category, uid);
    } else {
      this.props.getSubCategoryProducts(category, uid, subCategory);
    }
    this.props.getSubCategory(category, uid);
  }

  handle = (e, product, index) => {
    e.preventDefault();
    product = {
      ...product,
      mrp: product.mrp[index],
      price: product.price[index],
      description: product.description[index],
      image: product.image[index],
      stock: product.stock[index],
      index: index
    };

    if (localStorage.getItem('cart')) {
      var setcart = JSON.parse(localStorage.getItem('cart'));
      var container = setcart.filter(
        (item) => item.description === product.description
      );
      if (container.length === 0) {
        setcart[setcart.length] = { ...product, quantity: 1 };
        localStorage.setItem('cart', JSON.stringify(setcart));
        store.dispatch({ type: 'ADD_TO_CART', payload: { data: setcart } });
      }
    } else {
      var addtolocal = [{ ...product, quantity: 1 }];
      localStorage.setItem('cart', JSON.stringify(addtolocal));
      store.dispatch({ type: 'ADD_TO_CART', payload: { data: addtolocal } });
    }
  };
  handleRangeChange = (event) => {
    const maxvalue = event.target.value;
    this.setState({ ...this.state, maxvalue: maxvalue });
  };

  changeSubcategory = (subCategory) => {
    var category = this.props.match.params.category;
    var uid = this.props.match.params.uid;
    if (subCategory === 'all') {
      this.props.getAllProducts(category, uid);
    } else {
      this.props.getSubCategoryProducts(category, uid, subCategory);
    }
  };
  render() {
    const subCategories = this.props.subCategories;
    const products = this.props.products;
    return (
      <div style={{ paddingTop: '0' }}>
        {/* <SweetAlert
              show={this.state.show}
              text="Your Product added in Cart"
              onConfirm={() => this.setState({ show: false })}
            /> */}
        <div className="container-fluid" id="shopKeeper">
          {/* <h4 className=''></h4> */}
          <br />
          <br />
          {/* <div className="col-lg-1 col-sm-2"></div> */}
          <div id="shopCard" width="100%">
            <div className="row">
              <div className="col-4 col-lg-2">
                <img
                  src={this.props.vendor.image}
                  alt=""
                  width="80%"
                  style={{ maxHeight: '100px', borderRadius: '10px' }}
                />
              </div>
              <div className="col-8">
                <h4 style={{ color: 'white' }}>{this.props.vendor.name}</h4>
                <h5 style={{ color: 'white' }}>
                  Open from {this.props.vendor.opentime} to{' '}
                  {this.props.vendor.closetime}
                </h5>
                <h6 style={{ color: 'white' }}>{this.props.vendor.location}</h6>
              </div>
            </div>
          </div>
        </div>

        <section className="category-section spad">
          <div className="container">
            <div className="row">
              <div className="col-lg-2">
                <div className="filter-widget">
                  <h2 className="fw-title">Sub Categories</h2>
                  <ul className="category-menu">
                    <li onClick={() => this.changeSubcategory('all')}>
                      <Link to="all">All Products</Link>
                    </li>
                    {!this.props.loader ? (
                      subCategories.map((subCategory) => (
                        <li
                          key={subCategory}
                          onClick={() => this.changeSubcategory(subCategory)}
                        >
                          <Link to={subCategory}>{subCategory}</Link>
                        </li>
                      ))
                    ) : (
                      <Loader
                        type="ThreeDots"
                        color="#d50000"
                        height={100}
                        width={100}
                        timeout={10000}
                      />
                    )}
                  </ul>
                </div>
              </div>
              <div className="col-lg-9  order-1 order-lg-2 mb-5 mb-lg-0">
                <div className="row ml-auto mr-auto">
                  <div className="col-12">
                    <h2>Products</h2>
                  </div>
                </div>
                <br />
                <div className="row">
                  {!this.props.loader ? (
                    products.map((product) => (
                      <div className="col-12 col-lg-6 display p-4 mb-5">
                        <h5>{product.name}</h5>
                        <div className="row">
                          {product.description.map((d, index) => (
                            <div>
                              {d === '' ? (
                                <></>
                              ) : (
                                <>
                                  {' '}
                                  <div className="row">
                                    {product.price[index] <
                                    product.mrp[index] ? (
                                      <span
                                        class="badge badge-success"
                                        style={{
                                          width: '20%',
                                          position: 'absolute'
                                        }}
                                      >
                                        On Sale
                                      </span>
                                    ) : null}
                                    <div className="col-3">
                                      <img
                                        src={d.image[index]}
                                        alt=""
                                        width="100%"
                                      />
                                      {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                    </div>
                                    <div className="col-6">
                                      <p>{product.description[index]}</p>
                                      {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                    </div>
                                    <div className="col-3">
                                      {+product.stock[index] > 0 ? (
                                        <button
                                          className="btn btnAdd"
                                          onClick={(event) =>
                                            this.handle(event, product, index)
                                          }
                                        >
                                          <i className="fa fa-plus"></i> Add
                                        </button>
                                      ) : (
                                        <button className="btn btnAdd">
                                          {' '}
                                          Out of stock
                                        </button>
                                      )}
                                      <h4>
                                        <span className="badge badge-info mt-4 ">
                                          ${product.price[index]}
                                        </span>
                                      </h4>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  ) : (
                    <Loader
                      type="ThreeDots"
                      color="#d50000"
                      height={100}
                      width={100}
                      timeout={10000}
                      style={{ 'margin-left': '400px' }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  subCategories: state.user.beer_subcategory,
  products: state.user.beer_products,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading
});

const mapDispatchToProps = (dispatch) => ({
  getAllProducts: (category, uid) => dispatch(getAllProducts(category, uid)),
  getSubCategoryProducts: (category, uid, subCategory) =>
    dispatch(getSubCategoryProducts(category, uid, subCategory)),
  getSubCategory: (category, uid) => dispatch(getSubCategory(category, uid)),
  getVendorDetails: (uid) => dispatch(getVendorDetails(uid))
});

export default connect(mapStateWithProps, mapDispatchToProps)(Shop2);
